<template>
  <default-layout>
    <div class="background">
      <Header />
      <h2 class="title">Page Not Found</h2>
    </div>
  </default-layout>
</template>

<script>
import DefaultLayout from "@/layouts/DefaultLayout";
import Header from "@/modules/Header";

export default {
  name: "NotFound",
  components: { Header, DefaultLayout }
}
</script>

<style lang="scss" scoped>
.title {
  font-size: 40px;
  font-weight: 600;
}

.background {
  display: flex;
  justify-content: center;
  align-items: center;

  text-align: center;

  min-height: 100vh;
}
</style>